import React from 'react';
import SliderSlick from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import slider1 from '../images/products/spacejoy.jpg';
import slider2 from '../images/products/michael-warf.jpg';
import slider3 from '../images/products/nathan-fertig.jpg';
import slider4 from '../images/products/toa-heftiba.jpg';


const Slider = () => {
	var settings = {
	    dots: true,
	    infinite: true,
	    speed: 500,
	    slidesToShow: 1,
	    slidesToScroll: 1
	  };

	return(
			<>
			    <section className="hero">
			        <div className="hero-container">
			        	<SliderSlick {...settings}>
					      <div>
						  <img src={'images/banner-2.png'} /> 
					      </div>
					      <div>
						  <img src={'images/banner-1.png'} />
					      </div>
					      <div>
						  <img src={'images/banner-3.png'} />
					      </div>
					      				     
					    </SliderSlick>
			        </div>
			    </section>
			</>
		)
}

export default Slider;